export interface ArticleSeo {
  metaTitle: string;
  metaDescription: string;
  ogTitle: string;
  ogDescription: string;
  canonical: string;
  datePublished: string;
  dateModified?: string;
  author: string;
  ogImage?: string;
}

export interface ArticleMeta {
  id: string;
  title: string;
  subtitle?: string;
  summary: string;
  date: string;
  readTime: string;
  category: string;
  slug: string;
  seo?: ArticleSeo;
  relatedSlugs?: string[];
}

export interface ArticleFaq {
  question: string;
  answer: string;
}

export interface ArticleContent {
  title: string;
  content: string;
  faqs?: ArticleFaq[];
}

export const articlesList: ArticleMeta[] = [
  {
    id: '13',
    title: '微生態護膚完整指南：益生菌護膚如何守護敏感肌與痘痘肌',
    subtitle: 'What is microbiome skincare？從乳酸菌發酵到肌膚屏障的完整解析',
    summary: '微生態護膚（microbiome skincare）是什麼？完整解析益生菌、乳酸菌發酵成分（Lactobacillus Ferment）如何守護肌膚屏障、平衡菌叢，特別適合敏感肌與痘痘肌的日常保養。',
    date: '2026-07-01',
    readTime: '9 分鐘',
    category: '肌膚微生態',
    slug: 'microbiome-skincare-guide',
    relatedSlugs: ['what-is-microbiome-skincare', 'skin-microbiome-guide', 'probiotic-skincare-guide'],
    seo: {
      metaTitle: '微生態護膚完整指南｜益生菌護膚如何守護敏感肌與痘痘肌｜Velireo Skin',
      metaDescription: 'What is microbiome skincare？完整解析益生菌與乳酸菌發酵成分如何守護肌膚屏障、平衡菌叢，敏感肌與痘痘肌的日常沐浴照護新選擇。',
      ogTitle: '微生態護膚完整指南｜益生菌護膚守護敏感肌與痘痘肌｜Velireo Skin',
      ogDescription: '完整解析益生菌與乳酸菌發酵成分如何守護肌膚屏障、平衡菌叢，敏感肌與痘痘肌的日常沐浴照護新選擇。',
      canonical: 'https://velireoskin.com/articles/microbiome-skincare-guide',
      datePublished: '2026-07-01',
      author: 'Velireo Skin',
    }
  },
  {
    id: '12',
    title: '沐浴油怎麼用？功效、用法與沐浴乳差別一次看懂',
    subtitle: '油轉乳科學×屏障修護×益菌平衡，搞懂為什麼沐浴油是身體保養的下一步',
    summary: '沐浴油是什麼？跟沐浴乳差在哪？完整解析油轉乳乳化原理、敏感肌與痘痘肌為什麼適合沐浴油，以及挑選沐浴油的 4 個關鍵指標。',
    date: '2026-06-08',
    readTime: '9 分鐘',
    category: '身體保養',
    slug: 'bath-oil-vs-shower-gel-comparison',
    relatedSlugs: ['shower-cream-oil-texture-guide', 'shower-cream-oil-guide', 'acid-vs-probiotic-back-acne'],
    seo: {
      metaTitle: '沐浴油怎麼用？功效、用法與缺點｜Velireo Skin',
      metaDescription: '沐浴油怎麼用才不會滑滑的？整理沐浴油功效、正確用法、常見缺點，以及和沐浴乳的差別，第一次用沐浴油先看這篇。',
      ogTitle: '沐浴油怎麼用？功效、用法與缺點｜Velireo Skin',
      ogDescription: '沐浴油怎麼用才不會滑滑的？整理沐浴油功效、正確用法、常見缺點，以及和沐浴乳的差別，第一次用沐浴油先看這篇。',
      canonical: 'https://velireoskin.com/articles/bath-oil-vs-shower-gel-comparison',
      datePublished: '2026-06-08',
      author: 'Velireo Skin',
    }
  },
  {
    id: '11',
    title: '微生態護膚是什麼？',
    subtitle: '益生元、益生菌、後生元差別與不分膚質保養完整解析',
    summary: '微生態護膚是什麼？完整解析益生元、益生菌、後生元差別，以及為什麼不分膚質保養可以從肌膚微生態開始。',
    date: '2026-05-22',
    readTime: '8 分鐘',
    category: '肌膚微生態',
    slug: 'what-is-microbiome-skincare',
    relatedSlugs: ['skin-microbiome-guide', 'probiotic-skincare-guide', 'shower-cream-oil-texture-guide'],
    seo: {
      metaTitle: '微生態護膚是什麼？益生元、益生菌、後生元差別完整解析｜Velireo Skin',
      metaDescription: '微生態護膚是什麼？完整解析益生元、益生菌、後生元差別，以及為什麼不分膚質保養可以從肌膚微生態開始。',
      ogTitle: '微生態護膚是什麼？益生元、益生菌、後生元差別完整解析｜Velireo Skin',
      ogDescription: '完整解析益生元、益生菌、後生元差別，以及為什麼不分膚質保養可以從肌膚微生態開始。',
      canonical: 'https://velireoskin.com/articles/what-is-microbiome-skincare',
      datePublished: '2026-05-22',
      author: 'Velireo Skin',
    }
  },
  {
    id: '6',
    title: '什麼是肌膚微生態？皮膚上的隱形守護者完整解析',
    summary: '完整解析肌膚微生態的運作原理、失衡原因與日常養護方法，了解為什麼維持菌叢平衡是肌膚健康的關鍵密碼。',
    date: '2026-02-21',
    readTime: '7 分鐘',
    category: '肌膚微生態',
    slug: 'skin-microbiome-guide',
    relatedSlugs: ['probiotic-skincare-guide', 'seasonal-skincare-strategy-2026', 'shower-cream-oil-texture-guide'],
    seo: {
      metaTitle: '什麼是肌膚微生態？認識皮膚菌叢與肌膚健康的關鍵連結｜Velireo Skin',
      metaDescription: '你知道皮膚上住著數兆微生物嗎？完整解析肌膚微生態的運作原理、失衡原因與日常養護方法，了解為什麼維持菌叢平衡是肌膚健康的關鍵密碼。',
      ogTitle: '什麼是肌膚微生態？認識皮膚菌叢與肌膚健康的關鍵連結｜Velireo Skin',
      ogDescription: '你知道皮膚上住著數兆微生物嗎？完整解析肌膚微生態的運作原理、失衡原因與日常養護方法。',
      canonical: 'https://velireoskin.com/articles/skin-microbiome-guide',
      datePublished: '2026-02-21',
      author: 'Velireo Skin',
    }
  },
  {
    id: '7',
    title: '益生菌護膚品怎麼挑？益生菌保養品成分與選購指南',
    summary: '益生菌護膚品到底有沒有效？完整解析益生菌、益生元、後生元三大成分差異，教你看懂成分表、聰明挑選適合自己的益菌護膚產品。',
    date: '2026-02-21',
    readTime: '8 分鐘',
    category: '益生菌護膚',
    slug: 'probiotic-skincare-guide',
    relatedSlugs: ['skin-microbiome-guide', 'shower-cream-oil-texture-guide', 'velireo-skin-brand-story'],
    seo: {
      metaTitle: '益生菌護膚品怎麼挑？成分與選購指南｜Velireo Skin',
      metaDescription: '益生菌護膚品怎麼挑？看懂益生菌、益生元、後生元差別，以及成分表上該找哪些字，挑選適合自己的益生菌保養品。',
      ogTitle: '益生菌護膚品怎麼挑？成分與選購指南｜Velireo Skin',
      ogDescription: '益生菌護膚品怎麼挑？看懂益生菌、益生元、後生元差別，以及成分表上該找哪些字，挑選適合自己的益生菌保養品。',
      canonical: 'https://velireoskin.com/articles/probiotic-skincare-guide',
      datePublished: '2026-02-21',
      author: 'Velireo Skin',
    }
  },
  {
    id: '8',
    title: '換季皮膚癢、乾燥脫皮怎麼辦？完整換季沐浴保養攻略',
    summary: '換季皮膚乾燥、搔癢、泛紅？從沐浴清潔到身體保養，一次掌握換季護膚的正確步驟，避開讓皮膚更慘的5個常見錯誤。',
    date: '2026-02-21',
    readTime: '7 分鐘',
    category: '換季保養',
    slug: 'seasonal-skincare-strategy-2026',
    relatedSlugs: ['shower-cream-oil-texture-guide', 'skin-microbiome-guide', 'bath-product-recommendation-2026'],
    seo: {
      metaTitle: '換季皮膚癢怎麼辦？皮膚科醫師認證的換季沐浴保養完整攻略｜Velireo Skin',
      metaDescription: '換季皮膚乾燥、搔癢、泛紅？從沐浴清潔到身體保養，一次掌握換季護膚的正確步驟，避開讓皮膚更慘的5個常見錯誤。',
      ogTitle: '換季皮膚癢怎麼辦？皮膚科醫師認證的換季沐浴保養完整攻略｜Velireo Skin',
      ogDescription: '換季皮膚乾燥、搔癢、泛紅？從沐浴清潔到身體保養，一次掌握換季護膚的正確步驟。',
      canonical: 'https://velireoskin.com/articles/seasonal-skincare-strategy-2026',
      datePublished: '2026-02-21',
      author: 'Velireo Skin',
    }
  },
  {
    id: '9',
    title: '沐浴油是什麼？Shower Oil、Shower Cream 中文與沐浴乳差異一次看懂',
    summary: '沐浴油霜到底是什麼質地？完整解析各種沐浴產品的質地特性、適合膚質與使用方式，幫你找到最適合的洗澡好夥伴。',
    date: '2026-02-21',
    readTime: '6 分鐘',
    category: '沐浴知識',
    slug: 'shower-cream-oil-texture-guide',
    relatedSlugs: ['seasonal-skincare-strategy-2026', 'bath-product-recommendation-2026', 'velireo-skin-brand-story'],
    seo: {
      metaTitle: '沐浴油是什麼？Shower Oil、Shower Cream 中文｜Velireo Skin',
      metaDescription: '沐浴油是什麼？shower oil、shower cream、shower gel 中文怎麼說、差在哪？一次看懂沐浴油、沐浴霜、沐浴油霜與沐浴乳的質地、洗感與適合膚質。',
      ogTitle: '沐浴油是什麼？Shower Oil、Shower Cream 中文｜Velireo Skin',
      ogDescription: '沐浴油是什麼？shower oil、shower cream、shower gel 中文怎麼說、差在哪？一次看懂沐浴油、沐浴霜、沐浴油霜與沐浴乳的質地、洗感與適合膚質。',
      canonical: 'https://velireoskin.com/articles/shower-cream-oil-texture-guide',
      datePublished: '2026-02-21',
      author: 'Velireo Skin',
    }
  },
  {
    id: '10',
    title: 'VELIREO SKIN 品牌故事：以益菌科學守護每一寸肌膚',
    summary: '認識 VELIREO SKIN 絲緞益菌——一個以微生態科學為核心、專注於益菌護膚的台灣品牌。了解我們為什麼選擇以益菌平衡取代傳統清潔思維。',
    date: '2026-02-21',
    readTime: '5 分鐘',
    category: '品牌故事',
    slug: 'velireo-skin-brand-story',
    relatedSlugs: ['skin-microbiome-guide', 'probiotic-skincare-guide', 'shower-cream-oil-texture-guide'],
    seo: {
      metaTitle: 'VELIREO SKIN 品牌故事｜以益菌科學守護肌膚的台灣護膚品牌｜Velireo Skin',
      metaDescription: '認識 VELIREO SKIN 絲緞益菌——一個以微生態科學為核心、專注於益菌護膚的台灣品牌。了解我們為什麼選擇以益菌平衡取代傳統清潔思維，以及絲緞益菌平衡沐浴油霜的誕生故事。',
      ogTitle: 'VELIREO SKIN 品牌故事｜以益菌科學守護肌膚的台灣護膚品牌｜Velireo Skin',
      ogDescription: '認識 VELIREO SKIN 絲緞益菌——一個以微生態科學為核心、專注於益菌護膚的台灣品牌。',
      canonical: 'https://velireoskin.com/articles/velireo-skin-brand-story',
      datePublished: '2026-02-21',
      author: 'Velireo Skin',
    }
  },
  {
    id: '1',
    title: '2026沐浴乳推薦11款：保濕、香氛到控油，各類型怎麼挑？',
    summary: '深入研究熱議話題，整理不同膚質、不同需求的沐浴乳推薦清單，教您挑選最適合的命定沐浴乳。',
    date: '2026-02-10',
    readTime: '10 分鐘',
    category: '沐浴推薦',
    slug: 'bath-product-recommendation-2026',
    relatedSlugs: ['sensitive-skin-body-wash-2026', 'shower-cream-oil-guide', 'body-skincare-guide'],
    seo: {
      metaTitle: '2026沐浴乳推薦11款｜澎澎、多芬、施巴到敏感肌，依膚質挑',
      metaDescription: '整理電商熱銷與專櫃沐浴乳共11款，依乾肌、油肌、敏感肌、香氛需求分類，附成分、pH值與價格比較表。',
      ogTitle: '2026沐浴乳推薦11款｜澎澎、多芬、施巴到敏感肌，依膚質挑',
      ogDescription: '整理電商熱銷與專櫃沐浴乳共11款，依乾肌、油肌、敏感肌、香氛需求分類，附成分、pH值與價格比較表。',

      canonical: 'https://velireoskin.com/articles/bath-product-recommendation-2026',
      datePublished: '2026-02-10',
      dateModified: '2026-10-12',
      author: 'Velireo Skin',
    }
  },
  {
    id: '2',
    title: '【皮膚科醫師推薦】2026敏感肌沐浴乳5款評比！告別乾癢、泛紅的安心清單',
    summary: '從皮膚科醫師的專業角度出發，教您看懂成分、避開地雷，精選5款好評敏感肌沐浴乳，讓沐浴回歸溫柔與療癒。',
    date: '2026-02-08',
    readTime: '8 分鐘',
    category: '敏感肌護理',
    slug: 'sensitive-skin-body-wash-2026',
    relatedSlugs: ['bath-product-recommendation-2026', 'acid-vs-probiotic-back-acne', 'body-skincare-guide'],
    seo: {
      metaTitle: '【皮膚科醫師推薦】2026敏感肌沐浴乳5款評比｜告別乾癢泛紅｜Velireo Skin',
      metaDescription: '皮膚科醫師推薦的2026年敏感肌沐浴乳清單！5款網友好評的溫和沐浴乳詳細評比，從成分、pH值到使用感受，幫你找到不刺激的安心選擇。',
      ogTitle: '【皮膚科醫師推薦】2026敏感肌沐浴乳5款評比｜告別乾癢泛紅｜Velireo Skin',
      ogDescription: '皮膚科醫師推薦的2026年敏感肌沐浴乳清單！5款網友好評的溫和沐浴乳詳細評比，從成分、pH值到使用感受，幫你找到不刺激的安心選擇。',
      canonical: 'https://velireoskin.com/articles/sensitive-skin-body-wash-2026',
      datePublished: '2026-02-08',
      author: 'Velireo Skin',
    }
  },
  {
    id: '3',
    title: '酸類成分 vs 益菌護膚：哪種沐浴乳才能真正解決背痘問題？',
    summary: '深入分析水楊酸、杏仁酸等酸類成分的優缺點與風險，介紹益菌護膚這個更溫和、更安全的背痘解決方案。',
    date: '2026-02-06',
    readTime: '12 分鐘',
    category: '背痘護理',
    slug: 'acid-vs-probiotic-back-acne',
    relatedSlugs: ['sensitive-skin-body-wash-2026', 'shower-cream-oil-guide', 'bath-product-recommendation-2026'],
    seo: {
      metaTitle: '酸類成分 vs 益菌護膚：背痘沐浴乳怎麼選？實測評比｜Velireo Skin',
      metaDescription: '背痘沐浴乳該選酸類還是益菌？深度評比水楊酸、果酸與益菌護膚成分的優缺點，網友實測心得彙整，找到真正有效的背痘解方。',
      ogTitle: '酸類成分 vs 益菌護膚：背痘沐浴乳怎麼選？實測評比｜Velireo Skin',
      ogDescription: '背痘沐浴乳該選酸類還是益菌？深度評比水楊酸、果酸與益菌護膚成分的優缺點，網友實測心得彙整，找到真正有效的背痘解方。',
      canonical: 'https://velireoskin.com/articles/acid-vs-probiotic-back-acne',
      datePublished: '2026-02-06',
      author: 'Velireo Skin',
    }
  },
  {
    id: '4',
    title: '沐浴油霜是什麼？沐浴乳 vs 沐浴油 vs 沐浴油霜，哪種才是護膚新寵？',
    summary: '深入探討沐浴油霜的質地科學、成分優勢，以及與沐浴乳、沐浴油的完整對比，幫助您找到最適合的沐浴產品。',
    date: '2026-02-04',
    readTime: '10 分鐘',
    category: '產品知識',
    slug: 'shower-cream-oil-guide',
    relatedSlugs: ['bath-product-recommendation-2026', 'acid-vs-probiotic-back-acne', 'body-skincare-guide'],
    seo: {
      metaTitle: '沐浴油霜推薦｜沐浴乳 vs 沐浴油 vs 沐浴油霜完整比較 2026｜Velireo Skin',
      metaDescription: '沐浴油霜推薦怎麼選？沐浴乳、沐浴油、沐浴油霜三種質地完整比較：清潔力、保濕度、適合膚質一次看懂，PTT/Dcard 網友激推，敏感肌乾性肌也適用。',
      ogTitle: '沐浴油霜推薦｜沐浴乳 vs 沐浴油 vs 沐浴油霜完整比較 2026',
      ogDescription: '沐浴油霜、沐浴乳、沐浴油到底差在哪？完整比較三者質地、清潔力與適用膚質，搞懂為什麼沐浴油霜成為敏感肌新寵。',
      canonical: 'https://velireoskin.com/articles/shower-cream-oil-guide',
      datePublished: '2026-02-04',
      author: 'Velireo Skin',
    }
  },
  {
    id: '5',
    title: '身體護膚完整指南：從清潔到保濕，打造光滑細緻肌膚的7步驟',
    summary: '提供完整的身體護膚7步驟指南，從清潔到特殊護理，解決乾癢、粗糙、背痘等常見問題，搭配季節性護膚方案。',
    date: '2026-02-02',
    readTime: '15 分鐘',
    category: '身體護膚',
    slug: 'body-skincare-guide',
    relatedSlugs: ['bath-product-recommendation-2026', 'sensitive-skin-body-wash-2026', 'shower-cream-oil-guide'],
    seo: {
      metaTitle: '身體護膚完整指南：7步驟打造光滑細緻肌膚｜Velireo Skin',
      metaDescription: '網友激推的身體護膚完整攻略！從清潔、去角質到保濕鎖水，7個步驟讓你從頭到腳擁有光滑細緻的肌膚，附專業產品推薦。',
      ogTitle: '身體護膚完整指南：7步驟打造光滑細緻肌膚｜Velireo Skin',
      ogDescription: '網友激推的身體護膚完整攻略！從清潔、去角質到保濕鎖水，7個步驟讓你從頭到腳擁有光滑細緻的肌膚，附專業產品推薦。',
      canonical: 'https://velireoskin.com/articles/body-skincare-guide',
      datePublished: '2026-02-02',
      author: 'Velireo Skin',
    }
  }
];

export { articlesContentArticle1 } from './articles/article1';
export { articlesContentArticle2 } from './articles/article2';
export { articlesContentArticle3 } from './articles/article3';
export { articlesContentArticle4 } from './articles/article4';
export { articlesContentArticle5 } from './articles/article5';
export { articlesContentArticle6 } from './articles/article6';
export { articlesContentArticle7 } from './articles/article7';
export { articlesContentArticle8 } from './articles/article8';
export { articlesContentArticle9 } from './articles/article9';
export { articlesContentArticle10 } from './articles/article10';
export { articlesContentArticle11 } from './articles/article11';
export { articlesContentArticle12 } from './articles/article12';

// Re-export combined content
import { articlesContentArticle1 } from './articles/article1';
import { articlesContentArticle2 } from './articles/article2';
import { articlesContentArticle3 } from './articles/article3';
import { articlesContentArticle4 } from './articles/article4';
import { articlesContentArticle5 } from './articles/article5';
import { articlesContentArticle6 } from './articles/article6';
import { articlesContentArticle7 } from './articles/article7';
import { articlesContentArticle8 } from './articles/article8';
import { articlesContentArticle9 } from './articles/article9';
import { articlesContentArticle10 } from './articles/article10';
import { articlesContentArticle11 } from './articles/article11';
import { articlesContentArticle12 } from './articles/article12';

export const articlesContent: Record<string, ArticleContent> = {
  ...articlesContentArticle1,
  ...articlesContentArticle2,
  ...articlesContentArticle3,
  ...articlesContentArticle4,
  ...articlesContentArticle5,
  ...articlesContentArticle6,
  ...articlesContentArticle7,
  ...articlesContentArticle8,
  ...articlesContentArticle9,
  ...articlesContentArticle10,
  ...articlesContentArticle11,
  ...articlesContentArticle12,
  // Alias: /articles/microbiome-skincare-guide reuses the comprehensive
  // microbiome article body from article11 to satisfy the SEO guide slug.
  'microbiome-skincare-guide': articlesContentArticle11['what-is-microbiome-skincare'],
};

